<div [class]="'tenant-' + consolidator">
  <div class="loading" *ngIf="showLoading">Loading&#8230;</div>
  <app-error [message]="errorMessage" *ngIf="showError"></app-error>
  <ng-container *ngIf="isTravelAgency">
    <div class="badge-only-agency">
      <span>{{ "HOME.AGENCYBADGE" | translate}}</span>
    </div>
  </ng-container>
  <app-header [consolidator]="consolidator" [isTravelAgency]="isTravelAgency" [lastUpdate]="lastUpdate" [iter]="iter"
    [logoAdv]="logoAdv" [logoTourOperator]="logoTourOperator" [selectLanguageView]="selectLanguageView"
    [topBarColor]="topBarColor" [mobileInfoVisible]="mobileInfoVisible"></app-header>

  <div class="wrapped">
    <button class="btn btn-primary print-btn-modal" (click)="openPrintModal()" *ngIf="showPrintButton && !isCancelledPractice">
      <i class="fas fa-print"></i> {{ (isTravelAgency && printEcEnabled ? 'COMMON.PRINT_OPEN_EC' : 'COMMON.PRINT_OPEN') | translate }}
    </button>

    <nav class="navbar navbar-expand-lg navbar-light bg-white sticky-top">
      <div class="collapse navbar-collapse justify-content-center navbar-principale" id="navbarSupportedContent">
        <ul ngbNav #nav="ngbNav" [(activeId)]="initialTab" class="border-0 nav-tabs">

          <li class="menu-separator" *ngIf="menuGroupStart('overview')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem="overview" *ngIf="!isCancelledPractice">
            <a ngbNavLink class="nav-link-overview" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'globe-africa'" [customPath]="getMenuIcon('overview')"></app-service-icon>
              </span>
              {{ "HOME.OVERVIEW" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-overview [days]="days" [urlCitiesImages]="urlCitiesImages" [citiesImages]="citiesImages"
                [iter]="iter" [lastUpdate]="lastUpdate" [state]="state" [serviceIcons]="serviceIcons" [version]="version"
                [noImageUrl]="noImageUrl" [defaultImages]="defaultImages">
              </app-overview>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('itinerary')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem *ngIf="!isCancelledPractice">
            <a ngbNavLink class="nav-link-itinerary" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'map-signs'" [customPath]="getMenuIcon('itinerary')"></app-service-icon>
              </span>
              {{ "HOME.ITINERARY" | translate | uppercase}}
              <!-- {{ (customLabels['HOME.ITINERARY'] || 'HOME.ITINERARY') | translate | uppercase }} -->
            </a>
            <ng-template ngbNavContent>
              <app-itinerary [days]="days" [hideCity]="enableTravelStepsTab" [version]="version"
                [urlCitiesImages]="urlCitiesImages" [enableItineraryViewServices]="enableItineraryViewServices"
                [itineraryMode]="itineraryMode"
                [showOptionlServices]="showOptionlServices" [noImageUrl]="noImageUrl"
                [defaultImages]="defaultImages"
                [enableTravelStepsTab]="enableTravelStepsTab" [totalPax]="getTotalPax()"
                [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"
                [serviceIcons]="serviceIcons" [enableSplitTransportTabs]="enableSplitTransportTabs"
                [enableFlightPassengers]="enableFlightPassengers"
                (navigateToTab)="onItineraryNavigate($event)"></app-itinerary>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('travel-steps')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem *ngIf="!isCancelledPractice && enableTravelStepsTab">
            <a ngbNavLink class="nav-link-travel-steps" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'shoe-prints'" [customPath]="getMenuIcon('travel-steps')"></app-service-icon>
              </span>
              {{ "HOME.TRAVEL_STEPS" | translate | uppercase}}
            </a>
            <ng-template ngbNavContent>
              <app-itinerary [days]="days" [hideCity]="false" [version]="version" [urlCitiesImages]="urlCitiesImages"
                [enableItineraryViewServices]="false" [showOptionlServices]="showOptionlServices"
                [noImageUrl]="noImageUrl" [defaultImages]="defaultImages" [ignoredIsoCodes]="ignoredIsoCodes"
                [enableTravelStepsTab]="enableTravelStepsTab" [totalPax]="getTotalPax()"
                [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"
                [serviceIcons]="serviceIcons" [enableSplitTransportTabs]="enableSplitTransportTabs"
                [enableFlightPassengers]="enableFlightPassengers"></app-itinerary>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('map')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem *ngIf="!isCancelledPractice">
            <a ngbNavLink class="nav-link-map" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'map'" [customPath]="getMenuIcon('map')"></app-service-icon>
              </span>
              {{ "HOME.MAP" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-map [steps]="steps"></app-map>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('hotels')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem="hotels" *ngIf="!isCancelledPractice && allDays.hotels.length > 0">
            <a ngbNavLink class="nav-link-sistemazioni" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'hotel'" [customPath]="getMenuIcon('hotels')"></app-service-icon>
              </span>
              {{ "HOME.SISTEMAZIONI" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-sistemazioni [days]="days" [showOptionlServices]="showOptionlServices"
                [noImageUrl]="noImageUrl" [defaultImage]="defaultImages.hotel"
                [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"
                [hideMedia]="hideHotelMedia"
                [serviceIcons]="serviceIcons"></app-sistemazioni>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('vehicles')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem="vehicles" *ngIf="!isCancelledPractice && allDays.cars.length > 0">
            <a ngbNavLink class="nav-link-rent-a-car" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'car-side'" [customPath]="getMenuIcon('vehicles')"></app-service-icon>
              </span>
              {{ "HOME.RENT-A-CAR" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-rent-a-car [days]="days" [version]="version" [noImageUrl]="noImageUrl"
                [defaultImage]="defaultImages.auto"
                [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"
                [serviceIcons]="serviceIcons"></app-rent-a-car>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('transfers')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem="transfers"
            *ngIf="!enableSplitTransportTabs && !isCancelledPractice && (allDays.transfers.length > 0 || showOptionlServices && allDays.transfersSuggested.length > 0 || allDays.flights.length > 0)">
            <a ngbNavLink class="nav-link-transport" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'taxi'" [customPath]="getMenuIcon('transfers')"></app-service-icon>
              </span>
              {{ "HOME.TRANSPORT" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-transport [days]="days" [version]="version" [noImageUrl]="noImageUrl"
                [defaultImage]="defaultImages.transfer" [showOptionlServices]="showOptionlServices"
                [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"
                [serviceIcons]="serviceIcons" [enableFlightPassengers]="enableFlightPassengers"></app-transport>
            </ng-template>
          </li>

          <li class="nav-item" ngbNavItem="flights"
            *ngIf="enableSplitTransportTabs && !isCancelledPractice && allDays.flights.length > 0">
            <a ngbNavLink class="nav-link-flights" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'plane'" [customPath]="getMenuIcon('flights')"></app-service-icon>
              </span>
              {{ "HOME.FLIGHTS" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-transport [days]="days" [version]="version" [noImageUrl]="noImageUrl"
                [defaultImage]="defaultImages.transfer" [showOptionlServices]="showOptionlServices"
                [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"
                [serviceIcons]="serviceIcons" [showTransfers]="false"
                [enableFlightPassengers]="enableFlightPassengers"></app-transport>
            </ng-template>
          </li>

          <li class="nav-item" ngbNavItem="transfers"
            *ngIf="enableSplitTransportTabs && !isCancelledPractice && (allDays.transfers.length > 0 || showOptionlServices && allDays.transfersSuggested.length > 0)">
            <a ngbNavLink class="nav-link-transfers" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'taxi'" [customPath]="getMenuIcon('transfers')"></app-service-icon>
              </span>
              {{ "HOME.TRANSFERS" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-transport [days]="days" [version]="version" [noImageUrl]="noImageUrl"
                [defaultImage]="defaultImages.transfer" [showOptionlServices]="showOptionlServices"
                [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"
                [serviceIcons]="serviceIcons" [showFlights]="false"></app-transport>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('activities')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem="activities"
            *ngIf="!isCancelledPractice && (allDays.optionals.length > 0 || showOptionlServices && allDays.optionalsSuggested.length > 0)">
            <a ngbNavLink class="nav-link-activities" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'landmark'" [customPath]="getMenuIcon('activities')"></app-service-icon>
              </span>
              {{ "HOME.ACTIVITIES" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-activities [days]="days" [version]="version" [noImageUrl]="noImageUrl"
                [defaultImage]="defaultImages.activity" [showOptionlServices]="showOptionlServices"
                [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"
                [serviceIcons]="serviceIcons" [hiddenCategories]="categoryBlacklist"></app-activities>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('tours')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem="tours" *ngIf="!isCancelledPractice && allDays.escorteds.length > 0">
            <a ngbNavLink class="nav-link-summary" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'bus'" [customPath]="getMenuIcon('tours')"></app-service-icon>
              </span>
              {{ "HOME.ESCORTEDS" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-escorted [days]="days" [version]="version" [noImageUrl]="noImageUrl"
                [defaultImage]="defaultImages.escorted" [totalPax]="getTotalPax()"
                [serviceIcons]="serviceIcons"
                [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"></app-escorted>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('documents')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem *ngIf="documents.length > 0 || pdfs.length > 0">
            <a ngbNavLink class="nav-link-summary" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'file-alt'" [customPath]="getMenuIcon('documents')"></app-service-icon>
              </span>
              {{ "HOME.DOCUMENTS" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-documents [days]="days" [pdf]="pdfs" [documents]="documents"></app-documents>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('other')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem *ngIf="showExtraTab">
            <a ngbNavLink class="nav-link-summary" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'plus-circle'" [customPath]="altriServiziIcon || getMenuIcon('other')"></app-service-icon>
              </span>
              {{ "HOME.OTHER" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <div id="extra" [class.altri-servizi-custom]="altriServiziActive">
                <app-extra [extra]="extra" [imageFee]="imageFee" [imageInsurance]="imageInsurance"
                  [days]="days" [personalized]="altriServiziActive" [deflusso]="altriServiziDeflusso"
                  [version]="version" [noImageUrl]="noImageUrl" [defaultImage]="defaultImages.activity"
                  [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes"
                  [serviceIcons]="serviceIcons"></app-extra>
              </div>
            </ng-template>
          </li>

          <ng-container *ngIf="isCancelledPractice || (!showSummaryClient && isTravelAgency || showSummaryClient)">
            <li class="menu-separator" *ngIf="menuGroupStart('summary')" aria-hidden="true"></li>

            <li class="nav-item" ngbNavItem="summary">
              <a ngbNavLink class="nav-link-summary" (click)="scrollToTop()">
                <span class="menu-icon" *ngIf="menuIconsEnabled">
                  <app-service-icon [icon]="'file-invoice-dollar'" [customPath]="getMenuIcon('summary')"></app-service-icon>
                </span>
                {{ "HOME.SUMMARY" | translate | uppercase }}
              </a>
              <ng-template ngbNavContent>
                <app-summary [consolidator]="consolidator" [insuranceSummaryVisible]="insuranceSummaryVisible"
                  [limitMarkup]="limitMarkup" [extra]="extra" [allDays]="allDays"
                  [enableAccountBalanceServicePriceDetails]="enableAccountBalanceServicePriceDetails"
                  [isFlightTaxInSummaryIncluded]="isFlightTaxInSummaryIncluded" [advInformations]="advInformations"
                  [showOnlyTotalPrice]="showOnlyTotalPrice" [showOptionlServices]="showOptionlServices"
                  [showSummaryDetail]="showSummaryDetail" [setTaxFlightFee]="setTaxFlightFee"
                  [passengers]="iter?.passengers" [amountApis]="iter?.financialSummary"
                  [commissionType]="iter?.commission_type" (eventAdvInformations)="getAdvInformations($event)"
                  [combinePriceServices]="combinePriceServices" [totalPax]="getTotalPax()"
                  [serviceIcons]="serviceIcons"></app-summary>
              </ng-template>
            </li>
          </ng-container>

          <li class="menu-separator" *ngIf="menuGroupStart('terms')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem *ngIf="!isCancelledPractice && terms">
            <a ngbNavLink class="nav-link-summary" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'file-contract'" [customPath]="getMenuIcon('terms')"></app-service-icon>
              </span>
              {{ "HOME.TERMS" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-terms [terms]="termsHtml" [tableBorders]="termsTableBorders" [imageSizes]="termsImageSizes"></app-terms>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('notes')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem *ngIf="showGeneralNotes">
            <a ngbNavLink class="nav-link-summary" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'sticky-note'" [customPath]="getMenuIcon('notes')"></app-service-icon>
              </span>
              {{ "HOME.NOTES" | translate | uppercase }}
            </a>
            <ng-template ngbNavContent>
              <app-notes [generalNotes]="generalNotes" [countryNotes]="countryNotes"
                [supplierNotes]="supplierNotes" [isTravelAgency]="isTravelAgency"
                [insurances]="extra?.insurances" [generalPdf]="generalPdf"
                [pdfLinksEnabled]="notesPdfEnabled" [language]="translateService.currentLang"
                [consolidator]="consolidator"></app-notes>
            </ng-template>
          </li>

          <li class="menu-separator" *ngIf="menuGroupStart('audit')" aria-hidden="true"></li>

          <li class="nav-item" ngbNavItem *ngIf="!isCancelledPractice && auditAgency && isTravelAgency">
            <a ngbNavLink class="nav-link-summary" (click)="scrollToTop()">
              <span class="menu-icon" *ngIf="menuIconsEnabled">
                <app-service-icon [icon]="'clipboard-check'" [customPath]="getMenuIcon('audit')"></app-service-icon>
              </span>
              AUDIT
            </a>
            <ng-template ngbNavContent>
              <app-audit [currentBookId]="iter?.riferimento"></app-audit>
            </ng-template>
          </li>

        </ul>

        <app-agency-info *ngIf="!mobileInfoVisible" class="d-lg-none mobile-agency-info" [iter]="iter"
          [lastUpdate]="lastUpdate" [logoAdv]="logoAdv" [consolidator]="consolidator"
          [isTravelAgency]="isTravelAgency"></app-agency-info>
      </div>
    </nav>

    <div [ngbNavOutlet]="nav" class="mt-2"></div>

    <button class="btn-feedback" (click)="open(feedbackModal)" *ngIf="isFeedbackEnabled && !isTravelAgency">
      <div class="content">
        <p class="name">{{supportName}}</p>
        <p class="text">{{ "FEEDBACK.SUPPORT-TEXT" | translate }}</p>
      </div>
      <div class="operator">
        <img [src]="supportPhoto" alt="Operator">
      </div>
    </button>

    <ng-template #feedbackModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title">{{ "FEEDBACK.TITLE" | translate }}</h5>
        <button type="button" class="close" (click)="modal.dismiss()">
          &times;
        </button>
      </div>

      <div class="modal-body ">
        <div class="container-feedback">
          <div class="row">
            <div class="col-12 bg-danger text-white mb-2 rounded-lg" *ngIf="errorMessage">
              <span>{{ errorMessage | translate }}</span>
            </div>

            <div class="col-12">
              <form [formGroup]="feedbackForm" (ngSubmit)="feedback()">
                <div class="form-group">
                  <label for="emailFrom">{{ "FEEDBACK.EMAIL" | translate }}</label>
                  <input required ngbAutofocus type="email" name="emailFrom" id="emailFrom" class="form-control"
                    formControlName="emailFrom" [placeholder]="'FEEDBACK.EMAIL-PLACEHOLDER' | translate">
                </div>

                <div class="form-group">
                  <label for="itinerary" class="label-checkbox">{{ "FEEDBACK.ITINERARY" | translate }}</label>
                  <ul class="list-inline rating-list">
                    <ng-container *ngFor="let star of stars; let i = index">
                      <li #itinerarybutton (click)="countStar(star, false)"
                        [ngClass]="{'selected': (star == itineraryValue)}">
                        <ng-container *ngIf="i === 0">
                          <i class="fas fa-frown-open"></i>
                        </ng-container>
                        <ng-container *ngIf="i === 1">
                          <i class="fas fa-frown"></i>
                        </ng-container>
                        <ng-container *ngIf="i === 2">
                          <i class="fas fa-meh"></i>
                        </ng-container>
                        <ng-container *ngIf="i === 3">
                          <i class="fas fa-smile"></i>
                        </ng-container>
                        <ng-container *ngIf="i === 4">
                          <i class="fas fa-laugh"></i>
                        </ng-container>
                      </li>
                    </ng-container>
                  </ul>
                  <input required type="hidden" [(ngModel)]="itineraryValue" name="itinerary" id="itinerary"
                    formControlName="itinerary">
                </div>

                <div class="form-group">
                  <label for="price" class="label-checkbox">{{ "FEEDBACK.PRICE" | translate }}</label>
                  <ul class="list-inline rating-list">
                    <ng-container *ngFor="let star of stars; let i = index">
                      <li #pricebutton (click)="countStar(star, true)" [ngClass]="{'selected': (star == priceValue)}">
                        <ng-container *ngIf="i === 0">
                          <i class="fas fa-frown-open"></i>
                        </ng-container>
                        <ng-container *ngIf="i === 1">
                          <i class="fas fa-frown"></i>
                        </ng-container>
                        <ng-container *ngIf="i === 2">
                          <i class="fas fa-meh"></i>
                        </ng-container>
                        <ng-container *ngIf="i === 3">
                          <i class="fas fa-smile"></i>
                        </ng-container>
                        <ng-container *ngIf="i === 4">
                          <i class="fas fa-laugh"></i>
                        </ng-container>
                      </li>
                    </ng-container>
                  </ul>
                  <input required type="hidden" [(ngModel)]="priceValue" name="price" id="price"
                    formControlName="price">
                </div>

                <div class="form-group">
                  <label for="message" class="label-checkbox">{{ "FEEDBACK.MESSAGE" | translate }}</label>
                  <textarea required name="message" id="message" cols="30" rows="10" class="form-control"
                    formControlName="message"></textarea>
                </div>

                <div>
                  <button type="submit" role="submit" class="btn btn-outline-secondary"
                    [disabled]="!feedbackForm.valid">
                    {{ "FEEDBACK.SEND" | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

  </div>

  <ngb-toast *ngIf="showToast" [class]="classToast" [autohide]="false">{{messageToast}}</ngb-toast>
  <app-footer [version]="version"></app-footer>
</div>